<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-0 ma-0 d-flex flex-column" style="height: 401px">
      <!-- Header -->
      <v-container class="chart-header pa-0 px-3 pt-3 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("sell_by_product_group") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 grey--text">
          {{ $t("sales_distribution_by_category") }}
        </v-card-text>
      </v-container>

      <!-- Pie Chart -->
      <apexchart
        v-if="hasData && hasCategoriesData"
        type="pie"
        height="225"
        :options="chartOptions"
        :series="series"
      />
      <!-- details -->
      <v-container v-if="hasData && hasCategoriesData" class="pa-0 px-3 ma-0">
        <v-list dense class="pa-0 ma-0">
          <v-list-item
            v-for="(item, index) in categoriesData"
            :key="index"
            class="pa-0 ma-0"
          >
            <v-list-item-content>
              <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
                <v-container class="pa-0 ma-0 d-flex flex-column">
                  <!-- title -->
                  <v-container class="pa-0 ma-0 d-flex align-center">
                    <v-card-text
                      class="legend-dot pa-0 ma-0 ml-2"
                      :style="{ backgroundColor: chartOptions.colors[index] }"
                    >
                    </v-card-text>
                    <span class="body-2"> {{ item.category }} </span>
                  </v-container>
                </v-container>
                <v-container class="pa-0 ma-0 d-flex" style="width: auto">
                  <v-card-text class="pa-0 ma-0 text-body-1">
                    {{ calcPercent(item.value) }}
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0 text-body-2">%</v-card-text>
                </v-container>
              </v-container>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
      <v-container
        v-if="!hasData && !hasCategoriesData"
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ApexChart from "vue-apexcharts";

const FALLBACK_COLORS = ["#3B82F6", "#EF4444", "#F59E0B", "#10B981"];

export default {
  name: "ProductByCategoryChart",
  components: {
    apexchart: ApexChart,
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      categoriesData: [],
      chartOptions: {
        chart: {
          fontFamily: "IRANSans",
          toolbar: { show: false },
          parentHeightOffset: 0,
        },

        labels: [],
        colors: [],
        legend: {
          show: false,
        },

        dataLabels: {
          enabled: false,
          formatter: function (_, opts) {
            return opts.w.globals.labels[opts.seriesIndex];
          },
          style: {
            fontSize: "12px",
            fontWeight: "500",
            colors: ["#111827"],
          },
          background: { enabled: false },
          dropShadow: { enabled: false },

          textAnchor: "middle",
          offset: 0,
          rotate: 0,
        },

        plotOptions: {
          pie: {
            dataLabels: {
              offset: 20,
              minAngleToShowLabel: 10,
            },
          },
        },

        tooltip: {
          y: {
            formatter: (value) => {
              return (
                value.toLocaleString("fa-IR") + " " + this.$store.state.currency.name
              );
            },
          },
        },
      },
    };
  },
  computed: {
    hasData() {
      return this.series.some((val) => val > 0);
    },
    hasCategoriesData() {
      return this.categoriesData.length > 0;
    },
    series() {
      return this.categoriesData.map((item) => item.value);
    },

    labels() {
      return this.categoriesData.map((item) => item.category);
    },
    totalValue() {
      return this.categoriesData.reduce((total, item) => total + item.value, 0);
    },
  },

  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getProductBycategory(newVal);
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getProductBycategory(newVal);
      },
    },
    labels: {
      immediate: true,
      handler(val) {
        this.chartOptions = {
          ...this.chartOptions,
          labels: val,
          colors: val.map((_, index) => FALLBACK_COLORS[index % FALLBACK_COLORS.length]),
        };
      },
    },
  },
  mounted() {
    this.getProductBycategory();
  },
  methods: {
    getProductBycategory(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/sales-by-group", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data || [];
          app.categoriesData = res
            .filter((item) => item.sell && item.sell.amount > 0)
            .map((item) => ({
              category: item.group_name,
              value: item.sell.amount,
            }));
        })
        .catch((error) => {
          console.error("compare sell and profit chart error:", error);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    calcPercent(value) {
      if (!this.totalValue) return 0;
      return ((value / this.totalValue) * 100).toFixed(1);
    },
    formatCurrency(value) {
      return value.toLocaleString("fa-IR");
    },
  },
};
</script>

<style scoped>
.chart-header {
  margin-bottom: 12px;
}
::v-deep .v-list--dense .v-list-item {
  min-height: 18px;
}
::v-deep .v-list-item__content {
  padding: 0px !important;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>
